/**
 * Takes the object `relatedLibraries` and uses it's `libraries` and `relations` to create a classDiagram.
 *
 * Generate mermaid class diagram code
 * See https://mermaid-js.github.io/mermaid/#/classDiagram
 *
 * @param libraryName - String identifying the library
 * @param relatedLibraries - Object - relating to the library
 * @returns {string} - Mermaid UML String
 */
export function makeLibraryRelationUml(libraryName, relatedLibraries) {
    let merString = 'classDiagram\n';

    relatedLibraries.libraries.forEach(lib => {
        merString += `class ${lib.name} {\n`;
        lib.attributes.forEach((attr) => {
            merString += `\t${attr}\n`;
        });

        merString += '}\n';

        if (lib.name !== libraryName) {
            merString += `click ${lib.name} href "/Library/${lib.name}" _self\n`;
        }
    });

    relatedLibraries.relations.forEach(rel => {
        merString += `${rel.fromName}-->${rel.toName} : ${rel.label}\n`;
    });

    return merString;
}
